import React from 'react';
import FieldMultiselect from "../../multiselect/multiselect";
import UserIconNew from "../../../../gd-ui/icon/user/user";

type FieldMultiselectGlistViewProps = {
    field       : FieldMultiselect
    model       : any,
    module      : any   // in this case this is glist !
    onClick?    : onClick
};

export default function FieldUsers_GlistView(props:FieldMultiselectGlistViewProps) {

    const value     = _.get(props.model, props.field.fieldId, null)
    const valueOptions   = props.field._getOptions(value)

    if (!valueOptions) return false;


    // calculate number of items based on available width
    const availableWidth:number = props.module.columns.get(props.field.fieldId).width - 20 // 2 x 10px padding
    const pillMaxWidth : number = 22 // user icon size - margin
    const itemsToShow:number    = Math.floor(availableWidth / pillMaxWidth)
    const moreOptions : number = (itemsToShow < valueOptions.length) ? valueOptions.length - itemsToShow : 0

    return (
        <div className={Classes("ui5-users-group")} onClick={props.onClick}>
            {_.map(valueOptions, (option, key:number)=>{
                if (key >= itemsToShow) return;
                return (
                    <div key={option.value} className="ico">
                        <UserIconNew className="user-icon" size="22" hint="up" userId={option.value}/>
                    </div>
                )
            })}

            {moreOptions > 0 &&
                <div key="more" className="ico">
                    <div className="ui5-counter circle-user">{"+{0}".f(moreOptions)}</div>
                </div>}
        </div>
    )

}
